var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg834722FacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 500,
    id: "svg2",
    width: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-552.36218)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 500,
    id: "rect3758-1",
    rx: 250,
    ry: 250,
    style: {
      fill: "#45619d",
      fillOpacity: 1,
      stroke: "none"
    },
    width: 500,
    x: 0,
    y: 552.36218
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 289.6875 60 C 221.90317 60 199.53125 91.10057 199.53125 144.4375 L 199.53125 186.65625 L 155 186.65625 L 155 250.03125 L 199.53125 250.03125 L 199.53125 440 L 281.65625 440 L 281.65625 250.03125 L 337.46875 250.03125 L 344.96875 186.65625 L 281.65625 186.65625 L 281.65625 149 C 281.65625 131.97966 285.39148 123.34375 311.8125 123.34375 L 344.96875 123.34375 L 344.96875 60 L 289.6875 60 z",
    id: "rect2989-1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(0,552.36218)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg834722FacebookIcon);
export default __webpack_public_path__ + "static/media/834722_facebook_icon.5ad0d6ce6f02f29cb7ca4874c59f464f.svg";
export { ForwardRef as ReactComponent };